// proto/v2/errors/errors.proto
//
// R7 — Consistent error handling. The single typed error contract carried on
// the wire for BOTH HTTP and WS. A backend mapper (internal/domain/errormap.go
// + services/server/error_envelope.go) is the only thing that constructs an
// ErrorEvent; the frontend switches on `code` via web/src/lib/errors/catalog.ts
// to render a warm, safe, localization-ready message.
//
// Layering of ErrorCode:
//   - 0           ERROR_CODE_UNSPECIFIED (never sent deliberately).
//   - 1..99       CORE block — coarse classes that every subsystem shares,
//                 mapped directly from the internal/domain sentinels.
//   - 100..       PER-FEATURE block, grouped by subsystem, for the precise
//                 conditions where a feature-specific message materially helps
//                 the user (e.g. "unlock your session" vs a generic 423).
//
// Each code maps (in Go, see internal/domain/errormap.go) to exactly one
// (http-status, retryable bool, safe user message). The safe message is the
// ONLY human prose on the wire — internal detail stays in server logs.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file errors/errors.proto (package lvdr.v2.errors, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file errors/errors.proto.
 */
export const file_errors_errors: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * LimitCut is one cut-and-mark record (LIMIT-04): a stored field or list was cut at
 * a limit instead of refused. Mirrors limitcap.Cut. limit and original count `unit`.
 * limit 0 = not known (an older writer), never "the limit was 0"; original 0 = not
 * measured.
 *
 * @generated from message lvdr.v2.errors.LimitCut
 */
export type LimitCut = Message<"lvdr.v2.errors.LimitCut"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: int64 limit = 2;
   */
  limit: bigint;

  /**
   * @generated from field: lvdr.v2.errors.LimitUnit unit = 3;
   */
  unit: LimitUnit;

  /**
   * @generated from field: int64 original = 4;
   */
  original: bigint;
};

/**
 * Describes the message lvdr.v2.errors.LimitCut.
 * Use `create(LimitCutSchema)` to create a new message.
 */
export const LimitCutSchema: GenMessage<LimitCut> = /*@__PURE__*/
  messageDesc(file_errors_errors, 0);

/**
 * LimitDetail is a refusal's numbers on a PERSISTED record (packet D16): the same meaning
 * as ErrorEvent's limit/limit_unit/current/retry_after_seconds/limit_window_seconds, for
 * records that are not a request reply (workflow steps and runs first, LIMIT-14).
 * 0 / UNSPECIFIED = not known.
 *
 * @generated from message lvdr.v2.errors.LimitDetail
 */
export type LimitDetail = Message<"lvdr.v2.errors.LimitDetail"> & {
  /**
   * @generated from field: lvdr.v2.errors.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: lvdr.v2.errors.LimitUnit limit_unit = 3;
   */
  limitUnit: LimitUnit;

  /**
   * @generated from field: int64 current = 4;
   */
  current: bigint;

  /**
   * @generated from field: int32 retry_after_seconds = 5;
   */
  retryAfterSeconds: number;

  /**
   * @generated from field: int32 limit_window_seconds = 6;
   */
  limitWindowSeconds: number;
};

/**
 * Describes the message lvdr.v2.errors.LimitDetail.
 * Use `create(LimitDetailSchema)` to create a new message.
 */
export const LimitDetailSchema: GenMessage<LimitDetail> = /*@__PURE__*/
  messageDesc(file_errors_errors, 1);

/**
 * ErrorEvent is the standard error payload. Carried on the MessageEnvelope
 * (field 570) for WS replies and serialised to JSON for HTTP responses via the
 * same mapper, so a single frontend catalog handles both surfaces.
 *
 * @generated from message lvdr.v2.errors.ErrorEvent
 */
export type ErrorEvent = Message<"lvdr.v2.errors.ErrorEvent"> & {
  /**
   * code is the typed class the frontend switches on.
   *
   * @generated from field: lvdr.v2.errors.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * message is the SAFE, user-facing, already-localizable string. It NEVER
   * contains internal detail, stack traces, or adversary-controlled (LLM /
   * crawled) text. The frontend may override it from its catalog by `code`,
   * but a non-empty value here is a safe default for older clients.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * field is set only for VALIDATION errors, naming the offending input field
   * (from domain.ValidationError.Field) so the UI can highlight it.
   *
   * @generated from field: string field = 3;
   */
  field: string;

  /**
   * retryable is the hint from the domain Transient/Permanent taxonomy. When
   * true the UI shows a consistent "Try again" affordance (and may auto-retry
   * transient classes). A locked-session error is retryable AFTER unlock.
   *
   * @generated from field: bool retryable = 4;
   */
  retryable: boolean;

  /**
   * debug_ref is an OPTIONAL server-side correlation id (NOT prose) the user
   * can quote to support so logs can be located. Never the raw error string.
   *
   * @generated from field: string debug_ref = 5;
   */
  debugRef: string;

  /**
   * feature is the capability id a PLAN_UPGRADE_REQUIRED refusal is about
   * (e.g. "workspaces", "docling_premium"); "" for every other code.
   *
   * @generated from field: string feature = 6;
   */
  feature: string;

  /**
   * required_tier is the lowest tier that grants feature ("minimum",
   * "standard", "plus", "max", "enterprise"); "" when unknown.
   *
   * @generated from field: string required_tier = 7;
   */
  requiredTier: string;

  /**
   * limit is the enforced value of the limit this refusal hit, for every limit
   * code; 0 when the refusal names none.
   *
   * @generated from field: int32 limit = 8;
   */
  limit: number;

  /**
   * retry_after_seconds is when a RATE_LIMITED refusal can be retried, from
   * the limiter that refused it (CHAT-71); 0 when unknown or not rate limited.
   *
   * @generated from field: int32 retry_after_seconds = 9;
   */
  retryAfterSeconds: number;

  /**
   * limit_unit is what limit and current count (LIMIT-03); UNSPECIFIED when the
   * refusal names no unit.
   *
   * @generated from field: lvdr.v2.errors.LimitUnit limit_unit = 10;
   */
  limitUnit: LimitUnit;

  /**
   * current is what the user had or sent when refused (LIMIT-03); 0 = not
   * measured, not "zero used".
   *
   * @generated from field: int64 current = 11;
   */
  current: bigint;

  /**
   * issues are the named field problems of a VALIDATION refusal (WF-38): one
   * per offending spec path. Each message is built from server constants and
   * the user's own values, never from LLM text. Empty for every other code.
   *
   * @generated from field: repeated lvdr.v2.errors.ValidationIssue issues = 12;
   */
  issues: ValidationIssue[];

  /**
   * limit_window_seconds is the window a rate limit counts over (LIMIT-07): a
   * RATE_LIMITED refusal of `limit` requests per window names both. 0 = not known.
   *
   * @generated from field: int32 limit_window_seconds = 13;
   */
  limitWindowSeconds: number;
};

/**
 * Describes the message lvdr.v2.errors.ErrorEvent.
 * Use `create(ErrorEventSchema)` to create a new message.
 */
export const ErrorEventSchema: GenMessage<ErrorEvent> = /*@__PURE__*/
  messageDesc(file_errors_errors, 2);

/**
 * ValidationIssue is one named problem in a submitted spec (WF-38).
 *
 * @generated from message lvdr.v2.errors.ValidationIssue
 */
export type ValidationIssue = Message<"lvdr.v2.errors.ValidationIssue"> & {
  /**
   * path names the offending field, e.g. "steps[draft].retry.max_attempts"
   * or "triggers[0].schedule".
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * code is the stable machine class the frontend localises by, e.g.
   * "cron_invalid", "cron_below_floor", "retry_max_attempts_above_limit".
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * params are the values the localised text interpolates ("floor": "5m").
   *
   * @generated from field: map<string, string> params = 3;
   */
  params: { [key: string]: string };

  /**
   * message is the English fallback; never LLM text.
   *
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * severity is "error" or "warning".
   *
   * @generated from field: string severity = 5;
   */
  severity: string;
};

/**
 * Describes the message lvdr.v2.errors.ValidationIssue.
 * Use `create(ValidationIssueSchema)` to create a new message.
 */
export const ValidationIssueSchema: GenMessage<ValidationIssue> = /*@__PURE__*/
  messageDesc(file_errors_errors, 3);

/**
 * ErrorCode is the typed, layered enumeration of every user-surfaceable error
 * class. The frontend catalog (web/src/lib/errors/catalog.ts) has one entry per
 * value; unknown values fall back to a single generic warm message, so adding a
 * code here is forward-compatible with older frontends.
 *
 * @generated from enum lvdr.v2.errors.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ---- CORE block (1..99) — one per internal/domain coarse class ----------
   * NOT_FOUND: a requested entity does not exist (or is hidden to avoid
   * leaking existence). Maps from domain.ErrNotFound / *NotFoundError.
   *
   * @generated from enum value: ERROR_CODE_NOT_FOUND = 1;
   */
  NOT_FOUND = 1,

  /**
   * CONFLICT: the request collides with current state (duplicate, already in
   * progress). Maps from domain.ErrConflict / domain.ErrExecutionInProgress.
   *
   * @generated from enum value: ERROR_CODE_CONFLICT = 2;
   */
  CONFLICT = 2,

  /**
   * VALIDATION: the request was malformed or failed a field-level check. Pairs
   * with ErrorEvent.field. Maps from domain.ErrValidation / *ValidationError.
   *
   * @generated from enum value: ERROR_CODE_VALIDATION = 3;
   */
  VALIDATION = 3,

  /**
   * UNAUTHORIZED: no / invalid authentication. Maps from domain.ErrUnauthorized.
   *
   * @generated from enum value: ERROR_CODE_UNAUTHORIZED = 4;
   */
  UNAUTHORIZED = 4,

  /**
   * FORBIDDEN: authenticated but not allowed to touch this resource.
   *
   * @generated from enum value: ERROR_CODE_FORBIDDEN = 5;
   */
  FORBIDDEN = 5,

  /**
   * BUDGET_EXHAUSTED: out of credits / budget. Maps from domain.ErrBudgetExhausted.
   *
   * @generated from enum value: ERROR_CODE_BUDGET_EXHAUSTED = 6;
   */
  BUDGET_EXHAUSTED = 6,

  /**
   * HITL_REQUIRED: a human-in-the-loop approval is needed before proceeding.
   * Maps from domain.ErrHITLRequired.
   *
   * @generated from enum value: ERROR_CODE_HITL_REQUIRED = 7;
   */
  HITL_REQUIRED = 7,

  /**
   * RATE_LIMITED: too many requests too fast. Retryable after a short wait.
   *
   * @generated from enum value: ERROR_CODE_RATE_LIMITED = 8;
   */
  RATE_LIMITED = 8,

  /**
   * UNAVAILABLE: a transient backend / dependency outage. Retryable.
   *
   * @generated from enum value: ERROR_CODE_UNAVAILABLE = 9;
   */
  UNAVAILABLE = 9,

  /**
   * INTERNAL: an unexpected server-side failure. The generic fallback for any
   * error the mapper does not recognise. Safe message never carries detail.
   *
   * @generated from enum value: ERROR_CODE_INTERNAL = 10;
   */
  INTERNAL = 10,

  /**
   * TIMEOUT: an operation exceeded its deadline. Retryable.
   *
   * @generated from enum value: ERROR_CODE_TIMEOUT = 11;
   */
  TIMEOUT = 11,

  /**
   * PAYLOAD_TOO_LARGE: an upload / request body exceeded the allowed size.
   *
   * @generated from enum value: ERROR_CODE_PAYLOAD_TOO_LARGE = 12;
   */
  PAYLOAD_TOO_LARGE = 12,

  /**
   * UNSUPPORTED_MEDIA: the provided file / media type is not accepted.
   *
   * @generated from enum value: ERROR_CODE_UNSUPPORTED_MEDIA = 13;
   */
  UNSUPPORTED_MEDIA = 13,

  /**
   * ---- Recordings & ASR (100..119) ----------------------------------------
   * RECORDING_SESSION_LOCKED: the per-user session is locked, so encrypted
   * audio cannot be decrypted. The "session locked, retry after unlock" path.
   * Retryable AFTER the user unlocks. Maps from recordings.ErrSessionLocked.
   *
   * @generated from enum value: ERROR_CODE_RECORDING_SESSION_LOCKED = 100;
   */
  RECORDING_SESSION_LOCKED = 100,

  /**
   * RECORDING_NOT_READY: transcript / promotion requested before the recording
   * finished transcribing. Maps from recordings.ErrNotReady.
   *
   * @generated from enum value: ERROR_CODE_RECORDING_NOT_READY = 101;
   */
  RECORDING_NOT_READY = 101,

  /**
   * RECORDING_UPLOAD_FAILED: ingest of an uploaded / imported recording failed.
   *
   * @generated from enum value: ERROR_CODE_RECORDING_UPLOAD_FAILED = 102;
   */
  RECORDING_UPLOAD_FAILED = 102,

  /**
   * RECORDING_TRANSITION_REFUSED: a cancel/retry was refused because the
   * recording had already left the status the operation requires — the user
   * pressed Cancel just as the job landed, or Retry on a row another tab had
   * already restarted. A BENIGN RACE, not a fault: the row's own status event
   * repaints it to the truth, so this code exists to be recognised and NOT
   * surfaced as an error toast (see web/src/features/execution/executionStore).
   * It is deliberately distinct from the generic CONFLICT, which is
   * DETAIL_PREFERRING and would therefore pin the English server string over
   * the localized catalog copy. Maps from recordings.ErrInvalidStatusTransition.
   *
   * @generated from enum value: ERROR_CODE_RECORDING_TRANSITION_REFUSED = 103;
   */
  RECORDING_TRANSITION_REFUSED = 103,

  /**
   * ---- Docling premium conversion (120..139) ------------------------------
   * Reserved for the docling subsystem (not present on this branch yet — the
   * codes are defined now so the contract is stable across the release).
   * DOCLING_QUOTA_EXCEEDED: the user's monthly docling page quota is used up.
   *
   * @generated from enum value: ERROR_CODE_DOCLING_QUOTA_EXCEEDED = 120;
   */
  DOCLING_QUOTA_EXCEEDED = 120,

  /**
   * DOCLING_RETRY_NOT_AVAILABLE: a free high-effort retry was requested but no
   * retry token exists (the original failure was a deterministic content error,
   * or the token expired / was already consumed).
   *
   * @generated from enum value: ERROR_CODE_DOCLING_RETRY_NOT_AVAILABLE = 121;
   */
  DOCLING_RETRY_NOT_AVAILABLE = 121,

  /**
   * ---- Engine / store ownership (140..159) --------------------------------
   * STORE_OWNER_MISMATCH: a research / project store was requested by a user
   * who does not own it (SEC-18). Surfaced as a NOT_FOUND-flavoured 404 to the
   * client to avoid leaking existence, but kept a distinct code server-side.
   *
   * @generated from enum value: ERROR_CODE_STORE_OWNER_MISMATCH = 140;
   */
  STORE_OWNER_MISMATCH = 140,

  /**
   * ---- Search providers (160..179) ----------------------------------------
   * SERPER_CAP_EXCEEDED: the per-run Serper request cap was hit (ENG-15).
   *
   * @generated from enum value: ERROR_CODE_SERPER_CAP_EXCEEDED = 160;
   */
  SERPER_CAP_EXCEEDED = 160,

  /**
   * ---- Notes & note assets (180..199) --------------------------------------
   * These existed in internal/domain (Code 180/181) before this enum caught
   * up — restoring the documented domain↔proto lockstep (R8 Phase 1b).
   * NOTE_SESSION_LOCKED: the per-user session is locked, so encrypted note
   * content cannot be decrypted. Retryable AFTER the user unlocks.
   *
   * @generated from enum value: ERROR_CODE_NOTE_SESSION_LOCKED = 180;
   */
  NOTE_SESSION_LOCKED = 180,

  /**
   * NOTE_ASSET_QUOTA_EXCEEDED: the user's note-asset storage quota (500MB v1)
   * is exhausted. 429-flavoured so the FE can distinguish it from a
   * single-file size rejection (413).
   *
   * @generated from enum value: ERROR_CODE_NOTE_ASSET_QUOTA_EXCEEDED = 181;
   */
  NOTE_ASSET_QUOTA_EXCEEDED = 181,

  /**
   * ---- Chat (200..219) ------------------------------------------------------
   * CHAT_SESSION_LIMIT: the per-user chat-session cap is reached. 429-flavoured
   * but NOT retryable — the user must delete an old conversation, so the copy
   * must not suggest waiting (R8 Phase 1b: distinct from RATE_LIMITED so the
   * localized message can say what actually helps).
   *
   * @generated from enum value: ERROR_CODE_CHAT_SESSION_LIMIT = 200;
   */
  CHAT_SESSION_LIMIT = 200,

  /**
   * CHAT_MESSAGE_LIMIT: the per-session message cap is reached — start a new
   * conversation. Same rationale as CHAT_SESSION_LIMIT.
   *
   * @generated from enum value: ERROR_CODE_CHAT_MESSAGE_LIMIT = 201;
   */
  CHAT_MESSAGE_LIMIT = 201,

  /**
   * CHAT_SESSION_LOCKED: a chat image attachment can't be stored/served because
   * the session is locked (no DEK). 423, retryable AFTER unlock. Vision input
   * (2026-07-07).
   *
   * @generated from enum value: ERROR_CODE_CHAT_SESSION_LOCKED = 202;
   */
  CHAT_SESSION_LOCKED = 202,

  /**
   * CHAT_IMAGE_GEN_SOVEREIGN_UNAVAILABLE: generate_image was reached in a
   * confidential turn or with no stamped image-egress decision (a workflow step),
   * but image generation runs on a non-sovereign external model (Gemini via
   * paperbanana). Refused, not downgraded, and no waiver covers it. Deck raises it
   * for a turn the waiver cannot cover (DECK-13). 403, not retryable this turn.
   * Image gen (2026-07-08).
   *
   * @generated from enum value: ERROR_CODE_CHAT_IMAGE_GEN_SOVEREIGN_UNAVAILABLE = 203;
   */
  CHAT_IMAGE_GEN_SOVEREIGN_UNAVAILABLE = 203,

  /**
   * IMAGE_GEN_SOVEREIGN_CONSENT_REQUIRED: image generation was asked for at a
   * sovereign floor with no valid waiver (DECK-13). Shared by deck and chat
   * (numbered in the chat block, where 203 lives). 403, not retryable: the user
   * grants the waiver in Settings → Privacy. Mirrors domain.CodeImageGenSovereignConsentRequired.
   *
   * @generated from enum value: ERROR_CODE_IMAGE_GEN_SOVEREIGN_CONSENT_REQUIRED = 204;
   */
  IMAGE_GEN_SOVEREIGN_CONSENT_REQUIRED = 204,

  /**
   * Demo guest session (220..239).
   * DEMO_READ_ONLY: a /demo guest attempted an action outside the read
   * allowlist. Deliberately distinct from FORBIDDEN — the frontend renders it
   * as an invitation to register, not as "you don't have access". 403, never
   * retryable (retrying without an account cannot succeed).
   * Mirrors domain.CodeDemoReadOnly; the two integers must stay in lockstep.
   *
   * @generated from enum value: ERROR_CODE_DEMO_READ_ONLY = 220;
   */
  DEMO_READ_ONLY = 220,

  /**
   * Subscription gate (240..259).
   * SUBSCRIPTION_REQUIRED: a registered user without a paid-or-granted
   * entitlement (Polar active/trialing/past_due, comp, or enterprise) reached a
   * product surface outside the gate's allowlist (BILL-03). The frontend routes
   * it to /plans rather than toasting. 402, not retryable (paying is the fix).
   * Mirrors domain.CodeSubscriptionRequired; the two integers must stay in lockstep.
   *
   * @generated from enum value: ERROR_CODE_SUBSCRIPTION_REQUIRED = 240;
   */
  SUBSCRIPTION_REQUIRED = 240,

  /**
   * PLAN_UPGRADE_REQUIRED: the caller's plan does not include the feature
   * (BILL-20a). ErrorEvent.feature names the capability id; required_tier is
   * the lowest tier that grants it, or "" when the server does not know it
   * (the frontend then reads its capability map). The frontend shows an
   * upgrade prompt, never the FORBIDDEN line. 403, not retryable.
   * Mirrors domain.CodePlanUpgradeRequired; the two integers must stay in
   * lockstep (internal/httperr/plan_upgrade_required_test.go).
   *
   * @generated from enum value: ERROR_CODE_PLAN_UPGRADE_REQUIRED = 241;
   */
  PLAN_UPGRADE_REQUIRED = 241,

  /**
   * Organisation security policy (260..279), MERIDIAN-66.
   * ORG_POLICY_EXCLUDES_ALL: the caller's org policy admits no model that could
   * serve this request. 403, not retryable (an org admin must change the policy).
   * Mirrors domain.CodeOrgPolicyExcludesAll; the two integers must stay in lockstep.
   *
   * @generated from enum value: ERROR_CODE_ORG_POLICY_EXCLUDES_ALL = 260;
   */
  ORG_POLICY_EXCLUDES_ALL = 260,

  /**
   * ORG_POLICY_UNAVAILABLE: the caller's org policy could not be read, so the
   * request was refused (fail-closed). 503, retryable (heals on the next load).
   * Mirrors domain.CodeOrgPolicyUnavailable; the two integers must stay in lockstep.
   *
   * @generated from enum value: ERROR_CODE_ORG_POLICY_UNAVAILABLE = 261;
   */
  ORG_POLICY_UNAVAILABLE = 261,

  /**
   * RESEARCH_CONCURRENCY_LIMIT: the owner already has their plan's number of
   * research runs going (BILL-10). 429, retryable: it clears when a run
   * finishes. Mirrors domain.CodeResearchConcurrencyLimit; the two integers
   * must stay in lockstep.
   *
   * @generated from enum value: ERROR_CODE_RESEARCH_CONCURRENCY_LIMIT = 280;
   */
  RESEARCH_CONCURRENCY_LIMIT = 280,

  /**
   * AI_CONCURRENCY_LIMIT: the AI gateway already runs the workspace's number of
   * requests at once (meridian tenant concurrency, LIMIT-03). 429, retryable: it
   * clears when one finishes. ErrorEvent.limit carries the number, limit_unit
   * REQUESTS. Mirrors domain.CodeAIConcurrencyLimit; the two integers must stay
   * in lockstep (internal/httperr TestAIConcurrencyLimitLockstep).
   *
   * @generated from enum value: ERROR_CODE_AI_CONCURRENCY_LIMIT = 281;
   */
  AI_CONCURRENCY_LIMIT = 281,
}

/**
 * Describes the enum lvdr.v2.errors.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_errors_errors, 0);

/**
 * LimitUnit is what ErrorEvent.limit and ErrorEvent.current count (LIMIT-03).
 * Mirrors domain.LimitUnit; the integers must stay in lockstep
 * (internal/httperr TestLimitUnitLockstep).
 *
 * @generated from enum lvdr.v2.errors.LimitUnit
 */
export enum LimitUnit {
  /**
   * @generated from enum value: LIMIT_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LIMIT_UNIT_ITEMS = 1;
   */
  ITEMS = 1,

  /**
   * @generated from enum value: LIMIT_UNIT_CHARACTERS = 2;
   */
  CHARACTERS = 2,

  /**
   * @generated from enum value: LIMIT_UNIT_BYTES = 3;
   */
  BYTES = 3,

  /**
   * @generated from enum value: LIMIT_UNIT_SECONDS = 4;
   */
  SECONDS = 4,

  /**
   * @generated from enum value: LIMIT_UNIT_REQUESTS = 5;
   */
  REQUESTS = 5,
}

/**
 * Describes the enum lvdr.v2.errors.LimitUnit.
 */
export const LimitUnitSchema: GenEnum<LimitUnit> = /*@__PURE__*/
  enumDesc(file_errors_errors, 1);

